// extracted by mini-css-extract-plugin
export default {"scope":"Invite_scope__QAVuu","button":"Invite_button__Y5hg-"};